import React from 'react';
import { Button } from './ui/button';
import { Facebook, Instagram, Heart } from 'lucide-react';

const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const navigationLinks = [
    { label: 'Home', id: 'home' },
    { label: 'About', id: 'about' },
    { label: 'Priorities', id: 'priorities' },
    { label: 'Get Involved', id: 'get-involved' },
    { label: 'Gallery', id: 'gallery' },
    { label: 'Contact', id: 'contact' },
  ];

  const socialLinks = [
    { 
      icon: Facebook, 
      url: 'https://www.facebook.com/share/1FrDLFBT8x/?mibextid=wwXIfr', 
      name: 'Facebook' 
    },
    { 
      icon: Instagram, 
      url: 'https://www.instagram.com/romanforseat2?igsh=MW1xNzBrcnRsMmlwMw%3D%3D&utm_source=qr', 
      name: 'Instagram' 
    },
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <div className="mb-6">
              <img
                src="https://customer-assets.emergentagent.com/job_wanda-for-kissimmee/artifacts/aax9kmpd_IMG_7910%20%281%29logo.png"
                alt="Wanda Roman Campaign"
                className="h-24 sm:h-28 md:h-32 w-auto object-contain"
              />
            </div>
            <p className="text-purple-300 text-lg font-semibold mb-4">
              For City of Kissimmee Commissioner – Seat 2
            </p>
            <p className="text-gray-400 mb-6 leading-relaxed">
              Leadership. Community. Progress. Together, we're building a stronger, more vibrant Kissimmee for everyone.
            </p>
            <a
              href="https://square.link/u/PPzV8yyu"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center bg-amber-500 hover:bg-amber-600 text-purple-900 font-bold px-6 py-3 rounded-lg transition-all duration-300 hover:scale-105"
            >
              <Heart className="mr-2 w-5 h-5 fill-current" />
              Support Our Campaign
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xl font-bold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {navigationLinks.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-gray-400 hover:text-purple-300 transition-colors"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-xl font-bold mb-6">Contact</h4>
            <div className="space-y-3 text-gray-400">
              <p>17 Broadway, Suite B</p>
              <p>Kissimmee, FL 34741</p>
              <p className="pt-2">Phone: 407-705-7281</p>
              <p>www.VoteWandaRoman.com</p>
            </div>
          </div>
        </div>

        {/* Social Media */}
        <div className="border-t border-gray-800 pt-8 mb-8">
          <div className="flex justify-center gap-4">
            {socialLinks.map((social, index) => {
              const Icon = social.icon;
              return (
                <a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 rounded-full bg-gray-800 hover:bg-purple-700 flex items-center justify-center text-gray-400 hover:text-white transition-all duration-300 hover:scale-110"
                  aria-label={social.name}
                >
                  <Icon className="w-5 h-5" />
                </a>
              );
            })}
          </div>
        </div>

        {/* Legal Disclaimer */}
        <div className="border-t border-gray-800 pt-8 text-center space-y-4">
          <p className="text-gray-400 text-sm leading-relaxed max-w-4xl mx-auto">
            <strong className="text-white">Political Advertisement</strong> – Paid for and Approved by Wanda Roman for City of Kissimmee Commissioner Seat 2
          </p>
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} Wanda Roman Campaign. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
